import React from "react";
import { useProvider } from "../components/StateProvider";
const Login = () => {
  const { provider, auth } = useProvider();
  const login = () => {
    auth
      .signInWithPopup(provider)
      .then((result) => {})
      .catch((err) => {
        alert(err.message);
      });
  };

  return (
    <>
      <div
        className="container d-flex align-items-center justify-content-center"
        style={{ minHeight: "100vh" }}
      >
        <div className="w-100 h-100" style={{ maxWidth: "400px" }}>
          <div className="card">
            <div className="card-title text-center ">
              <h1 className="mt-3">
                <i className="fas fa-music mr-2" />
                Musicify
              </h1>
            </div>
            <div className="card-body text-center">
              <div className="btn btn-primary" onClick={login}>
                <i class="fab fa-google mr-2"></i>
                Google Sign in
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
